module.exports = __webpack_public_path__ + "static/img/logo-vertical.20da533d.png";